module.exports = __webpack_public_path__ + "img/confirm_voltage_doorbell_transformer.629cf9b4.png";